import type { FaireProductEntity } from "../../entity_types/product";

export const p_xbfdvzf4w3: FaireProductEntity = {
  token: "p_xbfdvzf4w3",
  type: "product",
  name: "Brain Dump Notepad: Pink 50-Page Daily ADHD Planner",
  brandName: "Eleventh and Taylor",
  imageUrl:
    "https://cdn.faire.com/fastly/03e9b9f2be4780b5e84909db07bf5d0bff9342a270ca0c52e3ee6b78e9fd03c5.png",
  priceDollars: 4.5,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/0a0d55ad7bcca37618e7f2021ac77bcab882c59d7166c93ed3983936424197d2.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
